import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;

    .warning {
        display: flex;
        gap: 16px;
    }
`;

export const Main = styled.div<{ sidebarFiltrosOpen?: boolean }>`
    width: 100%;
    overflow: auto;
    max-height: 100vh;
    padding: 32px;
    padding-bottom: 64px;
    background-color: ${(props: any) => props.theme.colors.background};
    transition: margin-right 0.3s ease;
    position: relative;
    z-index: 1;

    ${({ sidebarFiltrosOpen }) => sidebarFiltrosOpen && `
        margin-right: 400px;

        @media (max-width: 768px) {
            margin-right: 100vw;
        }
    `}

    @media (max-width: 740px) {
        /* padding-top: 60px; */
        /* padding-left: 60 */
        }
`;